import React from "react";
import { Navigate } from "react-router-dom";
import { isLogin } from "../../context/auth/auth.provider";

const GuestRoute = ({ children }) => {
  return !isLogin() ? children : <Navigate to="/" />;
};

export default GuestRoute;
